"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.newType = void 0;
// tslint:disable-next-line: only-arrow-functions
var newType = function (type) {
    var _args = [];
    for (var _i = 1; _i < arguments.length; _i++) {
        _args[_i - 1] = arguments[_i];
    }
    // tslint:disable
    // eslint-disable-next-line
    return new (Function.prototype.bind.apply(type, arguments));
};
exports.newType = newType;
